import config from '../../config';
import { HTTP } from  '../../http';
import _ from "lodash";

const pageSize = 25;
const devicesUri = config.apiEndpoints.devicesUri;
const deviceStatuses = [    
    {
      id: 'OPEN',
      name: "Livre"
    },
    {
      id: 'ATTACHED',
      name: "Vinculado"
    },
    {
      id: 'ENABLED',
      name: "Ativo"
    },
    {
      id: 'DISABLED',
      name: "Inativo"
    },
    {
      id: 'DANIFIED',
      name: "Danificado"
    }
  ];

export function queryStringParams(request) {
    const serialNumber = request.serialNumber == '' ? '' : `&serialNumber=${request.serialNumber}`;
    const logicNumber = request.logicNumber == '' ? '' : `&logicNumber=${request.logicNumber}`;
    const modelId = request.modelId == null ? '' : `&modelId=${request.modelId}`;
    const status = request.status == null ? '' : `&status=${request.status}`;
    const sellerId = request.sellerId == null ? '' : `&sellerId=${request.sellerId}`;
    return `${serialNumber}${logicNumber}${modelId}${status}${sellerId}`;
}
export function queryStringUsageParams(request) {
    const serialNumber = request.serialNumber == '' ? '' : `&serialNumber=${request.serialNumber}`;
    const modelId = request.modelId == null ? '' : `&modelId=${request.modelId}`;
    const daysWithoutTransaction = request.daysWithoutTransaction == null ? '' : `&daysWithoutTransaction=${request.daysWithoutTransaction}`;
    const sellerId = request.sellerId == null ? '' : `&sellerId=${request.sellerId}`;
    return `${serialNumber}${modelId}${daysWithoutTransaction}${sellerId}`;
}
export function queryStringStatusHistoriesParams(request) {
    const serialNumber = request.serialNumber == '' ? '' : `&serialNumber=${request.serialNumber}`;
    const sellerId = request.sellerId == null ? '' : `&sellerId=${request.sellerId}`;
    return `${serialNumber}${sellerId}`;
}
export default {
    findAll: (request) => {
        return new Promise((resolve, reject) => {
            request.pageSize = pageSize
            
            HTTP.get(devicesUri.concat('search'),{ params: request}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAllExport: (request) => {        
        return new Promise((resolve, reject) => {
            HTTP.get(`${devicesUri}search/export?${queryStringParams(request)}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {                
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        });        
    },
    findAllStatusHistories: (request) => {
        return new Promise((resolve, reject) => {
            request.pageSize = pageSize
            
            HTTP.get(devicesUri.concat('statushistories'),{ params: request}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAllUsage: (request) => {
        return new Promise((resolve, reject) => {
            request.pageSize = pageSize
            
            HTTP.get(devicesUri.concat('usage'),{ params: request}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    findAllUsageExport: (request) => {        
        return new Promise((resolve, reject) => {
            HTTP.get(`${devicesUri}usage/export?${queryStringUsageParams(request)}`,
            {
                responseType: 'blob'
            }
            )
            .then(response => {                
                let blob = new Blob([response.data], { type: 'text/csv' });
                let url = window.URL.createObjectURL(blob);
                resolve(url);               
            }, error => {
                reject(error);
            })
        });        
    },
    summary: (request) =>{
        return new Promise((resolve, reject) => {
            let req = {
                modelId: request.modelId,
                sellerId: request.sellerId,
                status: request.status
            }
            HTTP.get(config.apiEndpoints.devicesUri.concat('summary'), {params: req}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords) => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.devicesUri.concat(`?keywords=${keywords}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.devicesUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.devicesUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.devicesUri, model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    associate: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.devicesUri.concat(`${model.serialNumber}/${model.sellerId == null || model.sellerId == '' ? 'detach/' : 'attach/' + model.sellerId }`), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    detach: (serialNumber) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.devicesUri.concat(`${serialNumber}/detach/`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    danify: (serialNumber, description) => {
        return new Promise((resolve, reject) => {
            let model = {
                serialNumber: serialNumber,
                description: description
            }
            HTTP.put(config.apiEndpoints.devicesUri.concat(`${serialNumber}/danify/`), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    getDeviceStatusList: () => {
        return _.clone(deviceStatuses);
    },
    getStatusName: (status) => {
        let s = deviceStatuses.find(function(item) { return item.id == status });
        if(s == null) {
            return '';
        }
        return s.name;
    }
    
}